import { CPLAnalytics } from "setup/appInsights/CPLAnalytics";
import ClientBudgetHeaderChargesTable from "./components/ClientBudgetHeaderChargesTable";
import PageWrapper from "app/modules/shared/PageWrapper";
import { useParams } from "react-router-dom";

const ClientBudgetHeadersTablePage: React.FC = () => {
  const { clientID, budgetID } = useParams();

  return (
    <CPLAnalytics pageName="Client Budget Header Charges">
      <PageWrapper
        data-test-id="budget-header-charges-page__back-button"
        title="Budget Header Charges"
        backTo={`/ClientBudgets/${clientID}/${budgetID}`}
      >
        <ClientBudgetHeaderChargesTable />
      </PageWrapper>
    </CPLAnalytics>
  );
};

export default ClientBudgetHeadersTablePage;
